export default {
  baseUrl: "/cmsapi",
  baseUrl2:"/donateApi",
  // baseUrl3: "http://srcs-cloud.eimm.wisesoft.net.cn:8099/cms" ,//测试环境
  baseUrl3: "http://220.167.103.104:8087/cms"  //正式环境
};
